import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-category.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-category.component.scss?ngResource";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from "@angular/core";
import { ApplicationSearchConstants } from "../application-search-constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject, take } from "rxjs";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
import { Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
let SearchCategoryComponent = class SearchCategoryComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    store;
    _destroy$ = new Subject();
    statusField;
    categoryLabel = ApplicationSearchConstants.FORM_CONTROLS.categoryLabel;
    categoryFormControl = ApplicationSearchConstants.FORM_CONTROLS.categoryFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    categoryForm;
    categoryList = [];
    tabChanged;
    applicationSearchCallback;
    getCategoryForModuleSubscription;
    getLookupsObservableSubscription;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, store) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.store = store;
    }
    ngOnInit() {
        this.categoryForm = new FormGroup({
            category: new FormControl(null)
        });
        this.getLookups();
    }
    searchApplication($event) {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val != null && this.tabChanged) {
                this.categoryForm = val;
            }
        });
        this.tabChanged = false;
        const category = this.categoryForm.get(this.categoryFormControl).value;
        if (category === "" || category === "") {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
            return;
        }
        else {
            if (!this.tabChanged) {
                this.applicationSearchCallback(this.applicationSearchService.searchByStatusOrTimeout(Number(this.appController.selectedModuleID), this.aflaModuleStrategyService, -9999, "", "", -9999, category));
            }
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'MetadataCategory'`,
        };
        this.getLookupsObservableSubscription = this.applicationSearchService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage("Search category", error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.categoryList = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "MetadataCategory") {
                    this.categoryList.push(JSON.parse(item.content).value);
                }
            });
        }
        this.categoryList.sort((a, b) => (a.localeCompare(b)));
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: Store }
    ];
    static propDecorators = {
        statusField: [{ type: Input }]
    };
};
SearchCategoryComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-category",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchCategoryComponent);
export { SearchCategoryComponent };
